export default "__VITE_ASSET__DW83zqVZ__"